
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lyceen/a1connect-2",
      function () {
        return require("private-next-pages/lyceen/a1connect-2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lyceen/a1connect-2"])
      });
    }
  